module.exports = __webpack_public_path__ + "static/contact-40e3756759ae187f1a7ba6d097cbb48c.jpg";